var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranspose = function SvgTranspose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.342 20.082c.417 0 .65-.205.813-.738l.643-1.928h3.377l.642 1.928c.158.526.404.738.82.738.445 0 .739-.26.739-.67 0-.17-.041-.355-.116-.58l-2.564-7.254c-.232-.69-.567-.984-1.19-.984-.621 0-.956.3-1.195.984L.747 18.831c-.089.26-.13.438-.13.602 0 .396.294.649.725.649m1.825-3.855 1.285-3.945h.075l1.279 3.945zM16.3 11.893c0 .765.37 1.107 1.177 1.107h2.474c1.996 0 3.254-1.012 3.254-2.625 0-1.278-.793-2.146-2.05-2.29v-.068c.977-.26 1.544-1.005 1.544-2.051 0-1.408-1.032-2.297-2.68-2.297h-2.542c-.807 0-1.176.349-1.176 1.107zm1.546-4.28V4.9h1.852c.923 0 1.463.5 1.463 1.327 0 .922-.615 1.387-2.003 1.387zm0 4.157V8.782h1.975c1.156 0 1.805.574 1.805 1.538 0 .985-.663 1.45-2.297 1.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m9.41 14 4.094-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 9.25a.75.75 0 0 0 0 1.5zm3 .75h.75a.75.75 0 0 0-.75-.75zm-.75 3a.75.75 0 0 0 1.5 0zm-2.25-2.25h3v-1.5h-3zm2.25-.75v3h1.5v-3z"
  })));
};
export default SvgTranspose;